import React, { useEffect } from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import NavbarComponent from './NavbarComponent';
import Footer from './Footer';

const TermsPageS = () => {
  useEffect(() => {
      const hash = window.location.hash; // Extract hash from URL
      if (hash) {
        setTimeout(() => {
          const element = document.querySelector(hash);
          if (element) {
            requestAnimationFrame(() => {
              element.scrollIntoView({ behavior: 'smooth', block: 'start' });
            });
  
            // Fallback for elements near the bottom
            setTimeout(() => {
              window.scrollTo({ top: element.offsetTop, behavior: 'smooth' });
            }, 500);
          }
        }, 300); // Delay to ensure content is rendered
      }
    }, []);
    
  return (
    <>
      <NavbarComponent/>
        <Container className="my-4 terms-page">
          {/* Declaración de privacidad */}
          <section className="mb-4" id='s0'>
            <Row>
              <Col>
                <h2 className="terms-page-header">Declaración de Privacidad</h2>
                {/* <p>Manténgalo en blanco por ahora y haga clic en el enlace no debe abrir nada.</p> */}
              </Col>
            </Row>
          </section>

          {/* Términos de Uso */}
          <section className="mb-4" id='s1'>
            <Row>
              <Col>
                <h2 className="terms-page-header">Términos de Uso</h2>
                <p>
                  Al acceder y usar este sitio, usted acepta los siguientes términos y condiciones sin limitación ni calificación.
                </p>

                <h5 className="section-common-title">Cumplimiento de las Leyes</h5>
                <p>
                  Usted es responsable de cumplir con las leyes aplicables a su jurisdicción al acceder a este sitio. Cualquier información
                  que envíe a través de este sitio se tratará como no confidencial y no propietaria. Usted afirma que posee el
                  derecho legal para enviar dicha información.
                </p>

                <h5 className="section-common-title">Propiedad del Contenido</h5>
                <p>
                  A menos que se especifique lo contrario, todo el contenido de este sitio, incluidos textos, imágenes y su organización, es propiedad de 720
                  Degrees y sus afiliados. Todas las marcas mencionadas son propiedad de sus respectivos dueños.
                </p>

                <h5 className="section-common-title">Restricciones de Licencia</h5>
                <p>
                  Nada en este sitio otorga ninguna licencia o derecho sobre cualquier derecho de autor, patente, marca registrada o interés propietario de 720
                  Degrees o de cualquier tercero. El contenido, incluidos imágenes gráficas, audio, video, código HTML, botones y texto, no
                  puede ser copiado, reproducido, republicado, cargado, publicado, transmitido o distribuido sin el consentimiento previo por escrito de 720
                  Degrees. Puede descargar e imprimir una copia de los materiales para uso personal y no comercial solo si no los modifica
                  y conserva todos los avisos de derechos de autor y marcas comerciales.
                </p>

                <h5 className="section-common-title">Enviós de Ideas No Autorizados</h5>
                <p>
                  720 Degrees no acepta envíos de ideas no solicitadas fuera de las relaciones comerciales establecidas. Cualquier idea compartida
                  sin una relación confidencial documentada se considerará no confidencial; 720 Degrees puede desarrollar o divulgar
                  ideas similares sin compensarlo. Los envíos no autorizados pueden ser devueltos o destruidos a nuestra discreción sin
                  revisión detallada. Al enviar ideas a través de este sitio web, usted acepta estos términos.
                </p>

                <h5 className="section-common-title">Exención de Responsabilidad por Información</h5>
                <p>
                  La información proporcionada en este sitio se ofrece de forma gratuita solo con fines informativos y no crea una
                  relación comercial o de servicios profesionales entre usted y 720 Degrees. Los enlaces a sitios externos no son
                  endosos; 720 Degrees no es responsable por el contenido o los servicios de esos sitios. El uso que usted haga de la información de este sitio o de los sitios enlazados es bajo su propio riesgo.
                </p>

                <h5 className="section-common-title">Limitación de Responsabilidad</h5>
                <p>
                  Este sitio y su contenido se proporcionan "tal cual". 720 Degrees no ofrece garantías con respecto al sitio o cualquier servicio enlazado y renuncia expresamente a todas las garantías implícitas, incluidas aquellas de comerciabilidad y adecuación para un propósito particular. Ni 720 Degrees ni sus proveedores de servicios externos serán responsables de daños derivados de su uso de este sitio o servicios enlazados.
                </p>

                <h5 className="section-common-title">Ley Aplicable</h5>
                <p>
                  Este sitio se mantiene en la nube de AWS. Estos términos se rigen por las leyes de São Paulo, Brasil. Usted reconoce que 720 Degrees puede elegir la jurisdicción para cualquier procedimiento legal contra él.
                </p>
              </Col>
            </Row>
          </section>

          {/* Divulgación Responsable */}
          <section className="mb-4" id='s2'> 
            <Row>
              <Col>
                <h2 className="terms-page-header">Divulgación Responsable</h2>
                <p>
                  En 720 Degrees, priorizamos la seguridad de nuestras aplicaciones y los datos que gestionamos. Agradecemos cualquier información que
                  pueda ayudarnos a mejorar nuestra postura de seguridad.
                </p>
                <ul>
                  <li>
                    <strong>Protección Legal:</strong> Si informa una vulnerabilidad utilizando el proceso descrito y cumple con estos términos, no tomaremos acciones legales contra usted por acceso no autorizado para identificar la vulnerabilidad.
                  </li>
                  <li>
                    <strong>Proceso de Envió:</strong> Envíe informes de vulnerabilidades a info@720Degrees.ai, incluyendo:-<br/>
                    - Descripción de la vulnerabilidad<br/>
                    - URL relevante, dirección IP u otra información identificativa<br/>
                    - Pasos para reproducir el problema (incluidos registros o capturas de pantalla)<br/>
                    - Cómo descubrió el problema<br/>
                    - Impacto presumido<br/>
                    - Pasos sugeridos para la solución<br/>
                    - Su nombre e información de contacto
                  </li>
                  <li>
                    <strong>Alcance:</strong> No acceda a estaciones de trabajo, sistemas o redes de terceros. La protección legal no se aplica a dichos sistemas.
                  </li>
                  <li>
                    <strong>Metodología:</strong> Evite ataques de denegación de servicio o métodos destructivos. Detenga las pruebas una vez que identifique una vulnerabilidad y repórtela según las instrucciones.
                  </li>
                  <li>
                    <strong>Acceso a Datos:</strong> No debe acceder a datos personales de nuestros clientes o usuarios. Si adquiere dichos datos inadvertidamente, elimínelos de manera segura.
                  </li>
                  <li>
                    <strong>Propiedad Intelectual:</strong> Al enviar un informe, otorga a 720 Degrees una licencia perpetua para usar y divulgar la información proporcionada con fines de análisis y mejora.
                  </li>
                  <li>
                    <strong>Exención de Responsabilidad:</strong> 720 Degrees no es responsable de daños relacionados con su envío. Toda la información enviada se proporciona sin cargo, y no se pagarán tarifas por los envíos.
                  </li>
                  <li>
                    <strong>Ley Aplicable:</strong> Estos términos se rigen por las leyes de São Paulo, Brasil.
                    Al participar en este programa, reconoce y acepta estos términos. ¡Gracias por ayudarnos a mejorar nuestra seguridad!
                  </li>
                </ul>
              </Col>
            </Row>
          </section>

          {/* Preferencias de Cookies */}
          <section className="mb-4" id='s3'>
            <Row>
              <Col>
                <h2 className="terms-page-header">Preferencias de Cookies</h2>
                <p>
                  Utilizamos cookies para proporcionar mejores servicios personalizados. Tiene la opción de limitarse solo a las cookies esenciales.
                </p>
              </Col>
            </Row>
          </section>

          {/* Mapa del Sitio */}
          <section className="mb-4" id='s4'>
            <Row>
              <Col>
                <h2 className="terms-page-header">Mapa del Sitio</h2>
                {/* <p>El equipo técnico debe construirlo.</p> */}
              </Col>
            </Row>
          </section>
        </Container>
      <Footer/>
    </>
  );
};

export default TermsPageS;
